import { resolveEventIndex } from './dateHelpers';
import { formatStaffListForStore, normalizeStaffEntries, parseStaffEntry } from './staffEntry';

function normName(value) {
    return String(value || '').trim();
}

function calendarOf(value) {
    return String(value || '');
}

export function isSameEventRef(ev, eventRef) {
    if (!ev || !eventRef) return false;
    const evCal = calendarOf(ev.calendarId);
    const refCal = calendarOf(eventRef.calendarId);
    if (eventRef.gId && ev.gId) {
        return ev.gId === eventRef.gId && evCal === refCal;
    }
    return normName(ev.event) === normName(eventRef.event || eventRef.name) && evCal === refCal;
}

export function eventRefFromCopyArgs(eventName, calId) {
    if (eventName && typeof eventName === 'object') {
        return {
            gId: eventName.gId,
            event: eventName.event || eventName.name,
            calendarId: eventName.calendarId ?? calId,
        };
    }
    return { event: eventName, calendarId: calId };
}

export function formatIsoDayPl(iso) {
    const [year, month, day] = String(iso || '').split('-');
    if (!day || !month) return String(iso || '');
    return `${Number(day)}.${Number(month)}`;
}

function staffCountOf(ev) {
    const staff = Array.isArray(ev?.staff) ? ev.staff : [];
    return staff.filter((entry) => parseStaffEntry(entry)?.name).length;
}

/**
 * Inne dni tego samego wydarzenia (ten sam gId, albo nazwa + calendarId).
 * Źródłowy dzień jest pomijany. Szuka w obie strony, nie tylko +1 dzień.
 */
export function findSiblingEventDays(eventsByDate, sourceDate, eventRef) {
    const siblings = [];
    if (!eventRef) return siblings;

    Object.entries(eventsByDate || {}).forEach(([date, list]) => {
        if (date === sourceDate) return;
        const ev = (Array.isArray(list) ? list : []).find((item) => isSameEventRef(item, eventRef));
        if (!ev) return;
        const count = staffCountOf(ev);
        siblings.push({
            date,
            event: ev,
            staffCount: count,
            hasStaff: count > 0,
            needed: ev.needed,
        });
    });

    siblings.sort((a, b) => a.date.localeCompare(b.date));
    return siblings;
}

export function splitCopyTargets(siblings) {
    const list = Array.isArray(siblings) ? siblings : [];
    return {
        empty: list.filter((item) => !item.hasStaff),
        occupied: list.filter((item) => item.hasStaff),
    };
}

export function applyStaffCopyToDays(eventsByDate, { targets, eventRef, staff, needed }) {
    const next = { ...(eventsByDate || {}) };
    const storedStaff = formatStaffListForStore(normalizeStaffEntries(staff));
    const targetDates = Array.isArray(targets) ? targets : [];

    targetDates.forEach((target) => {
        const date = typeof target === 'string' ? target : target?.date;
        if (!date) return;
        const list = Array.isArray(next[date]) ? [...next[date]] : [];
        const idx = resolveEventIndex(list, {
            gId: eventRef?.gId,
            eventName: eventRef?.event || eventRef?.name,
            calendarId: eventRef?.calendarId,
        });
        if (idx < 0) return;
        const ev = { ...list[idx], staff: storedStaff };
        if (needed != null) {
            const n = Math.max(1, Number(needed) || 1);
            ev.needed = Math.max(n, storedStaff.length, 1);
        }
        list[idx] = ev;
        next[date] = list;
    });

    return next;
}
